<div
  *ngIf="isVisible"
  @fadeInOut
  id="popup-modal"
  tabindex="-1"
  class="flex items-center justify-center overflow-y-auto overflow-x-hidden fixed inset-0 bg-black bg-opacity-50 backdrop-filter"
  style="z-index: 10000">
  <div class="relative p-4 w-full max-w-md">
    <div class="p-5 relative bg-white dark:bg-night-900 dark:border dark:border-night-700 rounded-lg shadow dark:shadow-none">
      <div class="p-4 md:p-2 text-center">
        <ng-container *ngIf="type == 'error'">
          <app-icon-alert-error />
        </ng-container>
        <ng-container *ngIf="type == 'success'">
          <app-icon-alert-success />
        </ng-container>
        <ng-container *ngIf="type == 'warning'">
          <app-icon-alert-warning />
        </ng-container>
        <ng-container *ngIf="type == 'info'">
          <div class="flex justify-center mb-2">
            <div
              class="w-12 h-12 rounded-full bg-primary-50 dark:bg-night-950 text-primary-600 dark:text-primary-400 flex items-center justify-center">
              <app-icon-wrapper
                [icon]="'help'"
                [size]="'medium-large'"
                [color]="'currentColor'" />
            </div>
          </div>
        </ng-container>
        <div class="mb-5">
          <ng-container *ngIf="title">
            <app-label-modal-title [label]="title" />
          </ng-container>
          <ng-container *ngIf="subtitle">
            <app-label-modal-subtitle [label]="subtitle" />
          </ng-container>
        </div>
        <div class="flex justify-center gap-4">
          <app-button
            *ngIf="showReject"
            [variant]="'outline'"
            [label]="rejectLabel"
            [type]="'button'"
            [disabled]="isLoading"
            (click)="onReject.emit()" />
          <app-button
            *ngIf="showAccept"
            [variant]="'primary'"
            [label]="acceptLabel"
            [type]="'button'"
            [loading]="isLoading"
            [disabled]="isLoading"
            (click)="onAccept.emit()" />
        </div>
      </div>
    </div>
  </div>
</div>
